export default "__VITE_ASSET__DdPGhOvo__"